import createEntity from "./createEntity.js";
import api from "../api.js";
import router from '@/router';
import toast from "../toaster.js";

let videoList = createEntity({ namespaced: false });

const state = {
    videoDataLoading: false,
    videoId: null,
    searchText: '',
    scoringLogic: null,
    videoToEdit: null,
    s3Cred: null,
    videoTestResult: null,
    allTestResults: null
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    }
};

const getters = {
    videoList(state, getters, rootState, rootGetters) {
        return getters["videoList/query"](video => video.title.toLowerCase().indexOf(state.searchText.toLowerCase()) > -1)
            .sort(function (a, b) { return b.id - a.id });
    },

    videoToEdit(state, getters, rootState, rootGetters) {
        return state.videoToEdit;
    },

    scoringLogics(state, getters, rootState, rootGetters) {
        return state.scoringLogic;
    },

    s3Cred(state, getters, rootState, rootGetters) {
        return state.s3Cred;
    },

    videoTestResult(state, getters, rootState, rootGetters) {
        return state.videoTestResult;
    },

    anyTestResult(state, getters, rootState, rootGetters) {
        return state.allTestResults;
    }

};

const actions = {
    async loadVideos(context) {

        context.commit("update", { videoDataLoading: true });

        context.commit("update", { searchText: '' });

        if (context.getters["videoList"].length
            && JSON.parse(localStorage.getItem('userInfo')).privileges.indexOf('access-all-tenants') < 0) {
            context.commit("update", { videoDataLoading: false });
            return
        }

        let data = await api.getVideoForAdmin();

        context.commit("videoList/load", data);

        context.commit("update", { videoDataLoading: false });
    },

    async addVideo(context, { vm, data }) {
        await api.addVideo(data).then(async (response) => {

            data.id = response.id;
            data.uploadDate = new Date();
            data.uploadBy = context.rootState.userInfo.name;

            context.commit("videoList/add", data);

            context.commit("videoList/load", await api.getVideos());

            toast.showToasts(vm, 'Video Added Successfully', 'success');

            router.push("/admin/videos");

        }).catch((error) =>
            toast.showToasts(vm, 'Adding Video Failed', 'danger')
        )
    },

    async getVideoById(context, id) {
        let data = await api.getVideoById(id);
        context.commit("update", { videoToEdit: data });
    },


    async deleteVideo(context, { vm, id }) {

        await api.deleteVideo(id).then(() => {
            context.commit("videoList/delete", id);

            toast.showToasts(vm, 'Video Deleted Successfully', 'success');

        }).catch((error) =>
            toast.showToasts(vm, 'Deleting Video Failed.', 'danger')

        )
    },

    async updateVideo(context, { vm, video, thumbnail, intensity }) {

        video.thumbnail = thumbnail;
        video.intensity = intensity

        await api.updateVideo(video.id, video).then(() => {

            context.commit("videoList/update", video);

            toast.showToasts(vm, 'Video Updated Successfully', 'success');

            router.push("/admin/videos");

        }).catch((error) =>
            toast.showToasts(vm, 'Updating Video Failed', 'danger')
        )
    },

    async setVideoActiveState(context, data) {
        await api.updateVideo(data.id, data).then(() => {
            context.commit("videoList/update", data);
        })
    },

    searchVideo(context, searchText) {
        context.commit("update", { searchText: searchText });
    },

    async getScoringLogic(context) {
        if (!state.scoringLogic)
            await api.getScoringLogic().then((response) => {
                context.commit("update", { scoringLogic: response })
            });
    },

    async getS3Cred(context) {
            await api.getS3TempCred().then((response) => {
            context.commit("update", { s3Cred: response })
        })
    },

    async getVideoTestingResult(context, id) {
        let testResult = await api.getTestingResult(id);
        context.commit("update", {videoTestResult: testResult})
    },

    async getSessionData(context, data) {
        let sessionData = await api.getTrainerData(data);
        context.commit("update", { sessionData: sessionData })
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        videoList
    }
}